<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            报告单号：<span v-if="formData.exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.exchangeNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 新增</span>
            <span v-else class="information">

              {{
                formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
                  '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '99' ? '取消' : ''
              }}
            </span>
          </div>
          <div style="display:none">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <div class="fr" v-show="btn_no">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
              v-if="(addButton || editButton) && (formData.stat == 1 || formData.stat == 6)"
              @click="saveData('editForm')">保存
            </el-button>
            <el-button type="primary" command="a" class="button-sty" icon="el-icon-check"
              v-if="(formData.stat == 1) && formData.id && submitButton && !formData.processId" @click="commit('提交')">提交
            </el-button>
            <el-button type="primary" command="e" class="button-sty" icon="el-icon-check"
              v-if="formData.stat == 1 && formData.id && !formData.processId && flowSubmitButton" @click="startFlow">启动流程
            </el-button>
            <el-button type="primary" command="d" class="button-sty" icon="el-icon-close"
              v-if="(formData.stat == 1 || formData.stat == 6) && formData.id && cancelButton && !formData.processId"
              @click="commit('取消')">取消
            </el-button>
            <el-button type="primary" command="b" class="button-sty" icon="el-icon-refresh-right"
              v-if="formData.id && formData.stat == 2 && checkButton && !formData.processId" @click="commit('审核')">审核
            </el-button>
            <el-button type="primary" command="c" class="button-sty" icon="el-icon-refresh-right"
              v-if="formData.id && formData.stat == 2 && rejectButton && !formData.processId" @click="commit('驳回')">驳回
            </el-button>
          </div>
        </div>

        <div>

          <!-- 基本信息 -->
          <dix style="overflow: unset!important;
                overflow-y: scroll!important;
                height: 100vh!important;display: block ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>基本信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        单据状态
                      </th>
                      <td>
                        <el-select v-model="formData.stat" style="width:10vw!important ;" clearable disabled>
                          <el-option label="制单" :value="1" />
                          <el-option label="审核中" :value="2" />
                          <el-option label="已审核" :value="5" />
                          <el-option label="驳回" :value="6" />
                          <el-option label="取消" :value="99" />
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        单据类型
                      </th>
                      <td>
                        <el-select v-model="formData.billType" clearable style="width:10vw!important ;" :disabled="isZd">
                          <el-option :value="1" label="退货"></el-option>
                          <el-option :value="2" label="退换货"></el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        退换来源
                      </th>
                      <td>
                        <el-select v-model="formData.sourceType" clearable style="width:10vw!important ;" :disabled="isZd"
                          @clear="clearSourceType" @change="sourceTypeChange">
                          <el-option :value="1" label="安装工单"></el-option>
                          <el-option :value="2" label="维修工单"></el-option>
                          <el-option :value="3" label="委托维修"></el-option>
                          <el-option :value="4" label="事故报告"></el-option>
                          <el-option :value="5" label="质量报告"></el-option>
                          <el-option :value="9" label="其他"></el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red" v-show="this.needSourceNo">*</em>
                        来源单据
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.sourceNo" clearable
                          :readonly="!this.writeSourceNo"
                          :disabled="this.disabledSourceNo || isZd">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchOrder"></i>
                        </el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        机构名称
                      </th>
                      <td>
                        <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange"
                          :props="{ label: 'name', value: 'id', checkStrictly: true }" style="width:10vw!important ;" :disabled="true"  />
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        网点
                      </th>
                      <td v-if="justShow">{{ formData.siteName }}</td>
                      <td v-else-if="!!this.currentSiteData">
                        <el-input type="text" autocomplete="off" v-model="formData.siteName"
                          style="width:10vw!important ;" clearable :disabled="true">
                          <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                      </td>
                      <td v-else>
                        <el-input type="text" autocomplete="off" v-model="formData.siteName"
                          style="width:10vw!important ;" clearable @clear="clearSite">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                        </el-input>
                      </td>
                      <th><em class="f-red">*</em>联系人</th>
                      <td>
                        <el-input type="text" autocomplete="off" prop="siteMan" v-model="formData.siteMan" :disabled="isZd"
                          style="width:10vw!important;" clearable />
                      </td>
                      <th><em class="f-red">*</em>联系人电话</th>
                      <td>
                        <!-- <el-input type="text" autocomplete="off" v-model="formData.siteManMobile"
                          style="width:10vw!important;" clearable /> -->
                        <el-input type="text" autocomplete="off" v-model="callMobile1" clearable :disabled="isZd"
                          style="width:10vw!important;" />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        退换原因
                      </th>
                      <td>
                        <el-select v-model="formData.exchangeReason" style="width:10vw!important ;" :disabled="isZd" clearable>
                          <el-option v-for="item in exchangeReasonList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        退换分类
                      </th>
                      <td>
                        <el-select v-model="formData.exchangeType" style="width:10vw!important ;" :disabled="isZd" clearable @change="exchangeTypeChange" >
                          <el-option v-for="item in exchangeTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        是否直发机
                      </th>
                      <td>
                        <el-select v-model="formData.isDirectExchange" clearable :disabled="this.isDirectExchangeDisabled || isZd" style="width:10vw!important ;" >
                          <el-option :value="0" label="否"></el-option>
                          <el-option :value="1" label="是"></el-option>
                        </el-select>
                      </td>
                      <td rowspan="3">
                        <el-image  :src="formData.qrCode" v-if="formData.qrCode" alt="" style="margin-left: 30%;width: 100px; height: auto;" :preview-src-list="srcList"> </el-image>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        是否用户问题
                      </th>
                      <td>
                        <el-select v-model="formData.isUserQuestion" clearable  style="width:10vw!important ;" >
                          <el-option :value="0" label="否"></el-option>
                          <el-option :value="1" label="是"></el-option>
                        </el-select>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        问题描述
                      </th>
                      <td colspan="5">
                        <el-input type="textarea" autocomplete="off" v-model="formData.problemRemark" oninput="if(value.length>500){value=value.substring(0, 500)}"
                          style="width:49vw!important;" :disabled="isZd" clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        入库仓
                      </th>
                      <td>
                        <el-select v-model="formData.inWarehouseId" :disabled="able">
                          <el-option v-for="item in warehouseList" :key="item.id"
                            :label="item.warehouseName + '(' + item.warehouseCode + ')'" :value="item.id">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        出库仓
                      </th>
                      <td>
                        <el-select v-model="formData.outWarehouseId" :disabled="able">
                          <el-option v-for="item in warehouseList" :key="item.id"
                            :label="item.warehouseName + '(' + item.warehouseCode + ')'" :value="item.id">
                          </el-option>
                        </el-select>
                      </td>
                      <th style="visibility: hidden;"></th>
                          <td></td> <th style="visibility: hidden;"></th>
                          <td></td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        总部收货异常默认退回地区
                      </th>

                      <td colspan="3">
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="defaultReturnValues" :clearable="true" style="width:100%;" :disabled="isZd"
                              @change="handleChange3" ref="cascader3" :options="defaultReturnOption">
                            </el-cascader>
                          </template>
                        </el-form-item>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        详细地址
                      </th>
                      <td colspan="3">
                        <el-input type="text" :disabled="isZd" autocomplete="off" v-model="formData.defaultReturnAddress" clearable
                           />
                      </td>
                    </tr>
                    <!-- <div class="demo-image__preview">
                      <el-image style="position: absolute;right: 10px; top: 10px;" :src="url" :preview-src-list="srcList">
                      </el-image>
                    </div> -->
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>用户信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>

                      <!-- <th>
                      <em class="f-red">*</em>
                      出库仓
                    </th>
                    <td>
                      <el-input type="text"
                                autocomplete="off"
                                v-model="formData.outWarehouseName"
                                clearable :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showWarehousePop=true"></i>
                      </el-input>
                    </td> -->

                      <th>
                        <em class="f-red">*</em>
                        用户姓名
                      </th>
                      <td>
                        <el-input type="text" style="width:10vw!important;"  autocomplete="off" v-model="formData.userName" :disabled="isZd" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showCustProfile = true"></i>
                        </el-input>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        用户电话
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="callMobile2"
                          style="width:10vw!important;" :disabled="isZd" clearable />
                      </td>

                      <th>
                        VIP级别
                      </th>
                      <td>
                        <el-select v-model="formData.vipLevel" placeholder="请选择" clearable style="width: 7vw;" disabled="true">
                          <el-option v-for="item in dictTypesVipLevel" :key="item.id" :label="item.label" :value="item.id">
                          </el-option>
                        </el-select>
                      </td>
                      <th style="visibility: hidden;"></th>
                      <td>
                      </td>

                    </tr>

                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        地区
                      </th>

                      <td colspan="3">
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" style="width:100%;" :disabled="isZd"
                              @change="handleChange" ref="cascader" :options="areaOption">
                            </el-cascader>
                          </template>
                        </el-form-item>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        详细地址
                      </th>
                      <td colspan="3">
                        <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" autocomplete="off" v-model="formData.userAddress" clearable :disabled="isZd"
                           />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>产品信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        产品类型
                      </th>
                      <td>
                        <el-form-item :rules="[{ required: true, trigger: 'blur' }]" class="select_input">
                          <el-select v-model="formData.bigCategoryId" placeholder="大类" @change='productSelectOne' :disabled="checkOrder || isZd"
                            clearable style="width: 49%!important;">
                            <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <el-select v-model="formData.smallCategoryId" placeholder="小类" clearable :disabled="checkOrder"
                            style="width: 49%!important;margin-left:2%;">
                            <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        产品编码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemCode" clearable :disabled="checkOrder || isZd"
                          readonly
                          style="width:10vw!important;">
                          <i slot="suffix" class="el-input__icon el-icon-search" v-if="!this.checkOrder"
                            @click="showPreconditionDialog = true"></i>
                        </el-input>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        产品名称
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemName" clearable disabled
                          style="width:10vw!important;">
                        </el-input>
                      </td>

                      <th>
                        <em class="f-red" v-if="isMustBarcode">*</em>
                        产品条码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.barcode"  style="width:10vw!important;" @blur="barcodeBlur" :disabled="(checkOrderBarcode || isZd)"
                          clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        购买金额
                      </th>
                      <td>
                        <el-input type="number" autocomplete="off" v-model="formData.buyAmount" :disabled="isZd"
                          style="width:10vw!important;" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        购买日期
                      </th>
                      <td>
                        <el-date-picker v-model="formData.buyDate" type="date" placeholder="选择日期" :disabled="isZd"
                          value-format="yyyy-MM-dd 00:00:00" :picker-options="optionsDisable"
                          style="width:10vw!important;">
                        </el-date-picker>
                      </td>
                      <th>
                        气源名称
                      </th>
                      <td>
                        <el-select v-model="formData.gasType" style="width:10vw!important;" clearable :disabled="isZd">
                          <el-option v-for="item in gasTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div class="title first"><b>收货人信息</b></div>
                <el-collapse v-model="receiveCollapse">
                    <el-collapse-item name="1">
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        姓名
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.receiveMan" :disabled="able && formData.stat>1"
                          style="width:10vw!important;" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.receiveMobile" :disabled="able  && formData.stat>1"
                          style="width:10vw!important;" clearable />
                      </td>
                      <th style="visibility: hidden;"></th>
                          <td>  <el-input type="text" style="visibility: hidden;width:10vw!important;"  autocomplete="off" v-model="formData.userName" clearable>
                        </el-input></td>
                          <th style="visibility: hidden;"></th>
                          <td>  <el-input type="text" style="visibility: hidden;width:10vw!important;"  autocomplete="off" v-model="formData.userName" clearable>
                        </el-input></td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        收货地址
                      </th>
                      <td colspan="3">
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="receiveAreaValues" :clearable="true"
                              style="width:100%;" :disabled="able  && formData.stat>1" @change="handleChange2" ref="cascader2"
                              :options="receiveAreaOption">
                            </el-cascader>
                            <!-- :disabled="able" -->
                          </template>
                        </el-form-item>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        详细地址
                      </th>
                      <td colspan="3">
                        <el-input type="text" autocomplete="off" v-model="formData.receiveAddress" :disabled="able && formData.stat>1"
                           clearable />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </el-collapse-item>
                  </el-collapse>
              </div>

              <div class="d-item">
                <div class="title first"><b>物流信息</b></div>
                <el-collapse>
                    <el-collapse-item name="2">
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        旧机退货状态
                      </th>
                      <td>
                        <el-select v-model="formData.returnLogisticsStat" style="width:10vw!important;" :disabled="able"
                          clearable>
                          <el-option label="未发货" :value="0" />
                          <el-option label="已发货" :value="2" />
                          <el-option label="已签收" :value="5" />
                        </el-select>
                      </td>

                      <th>
                        退货物流公司名称
                      </th>
                      <td>
                        <el-select v-model="formData.returnLogisticsCompany" style="width:10vw!important;"
                          :disabled="able" clearable>
                          <el-option v-for="item in logisticsCompaniesList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>


                      <th>物流单号</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.returnLogisticsNo" :disabled="able"
                          style="width:10vw!important;" clearable />
                      </td>
                      <th>退货签收时间</th>
                      <td>
                        <el-date-picker v-model="formData.returnLogisticsSign" type="datetime" placeholder="选择日期时间"
                          :disabled="able" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                          style="width:10vw!important;">
                        </el-date-picker>
                      </td>

                    </tr>
                    <tr>
                      <th>
                        新机返还状态</th>
                      <td>
                        <el-select v-model="formData.backLogisticsStat" style="width:10vw!important;" :disabled="able"
                          clearable>
                          <el-option label="未发货" :value="0" />
                          <el-option label="已发货" :value="2" />
                          <el-option label="已签收" :value="5" />
                        </el-select>
                      </td>

                      <th>
                        返还物流公司名称
                      </th>
                      <td>
                        <el-select v-model="formData.backLogisticsCompany" style="width:10vw!important;" :disabled="able"
                          clearable>
                          <el-option v-for="item in logisticsCompaniesList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        返还单号</th>
                      <td><el-input type="text" autocomplete="off" v-model="formData.backLogisticsNo" :disabled="able"
                          clearable /></td>
                      <th>返还签收时间</th>
                      <td>
                        <el-date-picker v-model="formData.backLogisticsSign" type="datetime" placeholder="选择日期时间"
                          :disabled="able" value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        备注
                      </th>
                      <td colspan="7">
                        <el-input type="text" autocomplete="off" v-model="formData.remark" :disabled="able"
                           />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </el-collapse-item>
                  </el-collapse>
              </div>

              <div class="d-item">

                <div class="title first"><b>鉴定信息</b></div>
                    <el-collapse>
                    <el-collapse-item name="3">
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        质量鉴定
                      </th>
                      <td>
                        <el-select v-model="formData.qualityIdentify" style="width:10vw!important;" :disabled="able"
                          clearable>
                          <el-option v-for="item in qualityIdentifyList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        鉴定结果
                      </th>
                      <td>
                        <!-- <el-select v-model="formData.identifyResult" style="width:10vw!important;" :disabled="able"
                          clearable>
                          <el-option v-for="item in identifyResultList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select> -->
                        <el-input type="text" autocomplete="off" v-model="formData.identifyResultName" :disabled="able" />
                      </td>
                      <th>
                        责任鉴定
                      </th>
                      <td>
                        <el-select v-model="formData.responsibilityIdentify" style="width:10vw!important;"
                          :disabled="able" clearable>
                          <el-option v-for="item in responsibilityIdentifyList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        是否可维修
                      </th>
                      <td>
                        <el-select v-model="formData.canFix" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="否"></el-option>
                          <el-option :value="1" label="是"></el-option>
                        </el-select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </el-collapse-item>
                  </el-collapse>
              </div>
              <div class="d-item">
                <div>
                  <div class="title first"><b>处理方案</b></div>
                  <el-collapse>
                    <el-collapse-item name="4">
                  <table class="table-detail">
                    <tbody>
                      <tr>
                        <th>
                          处理方案名称
                        </th>
                        <td>
                          <el-select v-model="formData.dealWay" style="width:10vw!important;" :disabled="able" clearable>
                            <el-option v-for="item in dealWayList" :key="item.value" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </td>
                        <th>
                          系统建议方案
                        </th>
                        <td><el-input type="text" autocomplete="off" v-model="formData.systemSuggestDeal" :disabled="able"
                            style="width: 27vw!important;" clearable :disable="true" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
              <div class="d-item">
                <div>
                  <div class="title first" style="display: flex;align-items: center;">
                    <b>返还产品</b>
                    <div class="item-button" style="margin-top: 8px;">
                      <el-button type="primary" class="button-sty btn_zdy" @click="ableShowMulPreconditionDialog">
                        <i class="el-icon-plus"></i>
                        添加明细
                      </el-button>&nbsp;
                      <el-button type="primary" class="button-sty btn_zdy" @click="deleteItemData">
                        <i class="el-icon-delete"></i>
                        批量删除
                      </el-button>
                    </div>

                    <div class="amount" v-if="!isSite" ><span>返还金额：{{ formData.backAmount }}</span>
                      <span style="margin-left: 50px;">差额：{{
                        formData.differenceAmount }}</span>
                    </div>

                  </div>
                </div>
                <!-- <el-collapse>
                    <el-collapse-item name="5"> -->
                <div>
                  <vxe-table style="margin-top: 5px;" :stripe="true"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '80%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                    show-overflow height="110" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                    @checkbox-all="selectChangeEvent" :data="formData.backList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="itemCode" title="产品编码" width="250"></vxe-column>
                    <vxe-column field="itemName" title="产品名称" width="250"></vxe-column>
                    <vxe-column field="bigCategoryName" title="产品大类" width="150"></vxe-column>
                    <vxe-column field="smallCategoryName" title="产品小类" width="150"></vxe-column>
                    <vxe-column field="qty" title="数量" width="150">
                      <template #default="{ row }">
                        <vxe-input size="small" v-model="row.qty" type="number" min="1" max="1000"
                          :clearable="false"></vxe-input>
                        <span>{{ row.qty }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="price" title="单价" v-if="!isSite" width="150"></vxe-column>
                    <vxe-column field="amount" title="金额" v-if="!isSite" width="150"></vxe-column>
                    <vxe-column field="barcode" title="条码" v-if="!isSite" width="150"></vxe-column>
                  </vxe-table>
                </div>
              <!-- </el-collapse-item>
                  </el-collapse> -->
              </div>
              <div class="d-item">
                <div class="title first"><b>接口对接</b></div>
                <el-collapse>
                    <el-collapse-item name="6">
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        ERP销售传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send1Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        ERP销售传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send1Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        ERP销售对接单号
                      </th>
                      <td>
                        <el-input autocomplete="off" v-model="formData.send1No" :disabled="able"
                          placeholder="对接单号"></el-input>
                      </td>
                      <th>
                        ERP客户编码
                      </th>
                      <td>
                        <el-input autocomplete="off" v-model="formData.erpCustCode" :disabled="able"
                          placeholder="ERP客户编码"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        WMS锁库传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send2Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        WMS锁库传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send2Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        WMS锁库对接单号
                      </th>
                      <td>
                        <el-input v-model="formData.send2No" :disabled="able" placeholder="对接单号"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        ERP交货传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send3Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        ERP交货传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send3Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        ERP交货对接单号
                      </th>
                      <td>
                        <el-input v-model="formData.send3No" :disabled="able" placeholder="对接单号"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        WMS出库传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send4Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        WMS出库传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send4Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        WMS出库对接单号
                      </th>
                      <td>
                        <el-input v-model="formData.send4No" :disabled="able" placeholder="对接单号"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        ERP退货传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send5Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        ERP退货传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send5Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        ERP退货对接单号
                      </th>
                      <td>
                        <el-input v-model="formData.send5No" :disabled="able" placeholder="对接单号"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        ERP交货(退)传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send6Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        ERP交货(退)传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send6Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        ERP交货(退)对接单号
                      </th>
                      <td>
                        <el-input v-model="formData.send6No" :disabled="able" placeholder="对接单号"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        WMS入库传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send7Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        WMS入库传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send7Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        WMS入库对接单号
                      </th>
                      <td>
                        <el-input v-model="formData.send7No" :disabled="able" placeholder="对接单号"></el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        WMS取消传单备注
                      </th>
                      <td>
                        <el-input v-model="formData.send8Message" :disabled="able" placeholder="传单备注"></el-input>
                      </td>
                      <th>
                        WMS取消传单状态
                      </th>
                      <td>
                        <el-select v-model="formData.send8Flag" clearable :disabled="able" style="width:10vw!important;">
                          <el-option :value="0" label="未传"></el-option>
                          <el-option :value="1" label="失败"></el-option>
                          <el-option :value="2" label="已传"></el-option>
                        </el-select>
                      </td>
                      <th>
                        WMS取消对接单号
                      </th>
                      <td>
                        <el-input v-model="formData.send8No" :disabled="able" placeholder="对接单号"></el-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </el-collapse-item>
                  </el-collapse>
              </div>
              <div class="d-item">
                <div class="title first"><b @click="() => { showAssignDialog = true; }">附件信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th><em class="f-red">*</em>故障点照片</th>
                      <td colspan="">
                        <div class="form_picture" style="width:10vw!important;">
                          <div>
                            <!-- <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove1"
                              list-type="picture-card" :file-list="picList1"
                              :on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }"
                              :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                              :on-preview="handlePictureCardPreview" :headers="headers" >
                              <i slot="default" class="el-icon-plus"></i>
                            </el-upload> -->
                            <photo-upload :photo-url.sync="formData.sysmtomPic" />

                          </div>
                        </div>
                      </td>
                      <th><em class="f-red">*</em>安装环境图片</th>
                      <td>
                        <div style="width:10vw!important;">
                          <!-- <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove2"
                            list-type="picture-card" :file-list="picList2"
                            :on-success="(res, file, fileList) => { handleSuccess2(res, file, fileList) }"
                            :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                            :on-preview="handlePictureCardPreview" :headers="headers" >
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload> -->
                          <photo-upload :photo-url.sync="formData.installPic" />

                        </div>
                      </td>

                      <th><em class="f-red">*</em>铭牌信息图片</th>
                      <td>
                        <div style="width:10vw!important;">
                          <photo-upload :photo-url.sync="formData.labelPic" />

                        </div>
                      </td>

                      <th><em class="f-red">*</em>产品条码图片</th>
                      <td>
                        <div style="width:10vw!important;">
                          <photo-upload :photo-url.sync="formData.barcodePic" />

                        </div>
                      </td>
                    </tr>
                    <tr>

                      <th><em class="f-red">*</em>视频</th>
                      <td>
                        <div style="width:10vw!important;">
                      <td style="padding-left: 0!important;">
                        <div style="display: flex;">
                          <div @click="showVideo = true" class="videoAdd"> <i class="el-icon-plus"></i></div>

                          <div class="videoP" v-if="formData.vedioUrl">

                            <div style="width:40%;    position: relative;" class="videoImg">
                              <el-image style="width: 30px; height: 35px"
                              :src="require('@/views/dialogCommon/video.jpg')" fit="fit"></el-image>
                              <div @click="openVideo(formData.vedioUrl)" class="imgY"><i class="el-icon-video-play"></i></div>
                            </div>

                              <div style="width:50%;display:flex;    flex-direction: column;justify-content: space-between;align-items: flex-end;">
                                <span>{{formData.vedioName}}</span>
                                <div @click="handleDownload(formData.vedioName,formData.vedioUrl)">
                                  <el-tooltip class="item" effect="dark" content="下载" placement="top">
                                    <i class="el-icon-download"></i>
    </el-tooltip>
                                </div>
                              </div>

                          </div>
                        </div>
                        <!-- <el-upload style="display:flex" :action="api.uploadFileUrl" :headers="headers" accept=".mp4"
                          :on-preview="handlePictureCardPreview2" :on-success="uploadPictureSuccess"
                          :show-file-list="true" :on-remove="handleRemoveVideo" :on-change="uploadPictureChange"
                          list-type="picture-card" class="videoUpload">
                          <video v-if="formData.vedioUrl" width="100%" controls="controls" :src="formData.vedioUrl"
                            class="avatar"></video>
                          <i class="el-icon-plus"></i>
                        </el-upload> -->

                      </td>
              </div>
              </td>

              </tr>
              </tbody>
              </table>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                           @checkbox-all="selectChangeEvent" :data="formData.fileList">
                  <vxe-column field="fileName" title="附件名称" width="250">
                    <template #default="{ row }">
                      <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>
                    </template>
                  </vxe-column>

                  <vxe-column title="操作" width="150">
                    <template #default="{ row }">
                      <!-- 下载 -->
                      <div>
                      </div>
                      <div>
                        <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                             style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                        </el-tooltip>

                        <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                             style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
            </div>

            <!-- 流程 -->
            <wfView visible-key="showEdit" :wfData="wfData" :obj="fixData" :parent-target="_self" @reloadWf="reloadWf"
              @reload="$reloadHandle"></wfView>
            <div style="height:250px"></div>
        </div>
        </dix>

    </div>


    </el-form>
    <!-- 服务区域弹窗表 -->
  </div>
  <sitePop v-if="showSitePop" @commit="siteCommit" :visiable.sync="showSitePop" multi="true" />
  <!-- 视频上传 -->
  <videoDialog v-if="showVideo" @commitVideo="commitVideo" :visiable.sync="showVideo" multi="true" />

  <orderPop v-if="showOrderPop" @commit="orderCommit" :visiable.sync="showOrderPop" :showBigSiteName="true" :siteId="formData.siteId"
    :settleType="orderType" :isFromExchangeBill="orderType==2?1:0" :paramForQuery="true" :isExchange="isExchange" :statBegin="6" :statEnd="97" multi="true" />

  <accidentPop v-if="showAccidentPop" @commit="accidentCommit" :visiable.sync="showAccidentPop" :siteId="formData.siteId"
    multi="true" />

  <qualityPop v-if="showQualityPop" @commit="qualityCommit" :visiable.sync="showQualityPop" :siteId="formData.siteId"
    multi="true" />

  <custProfileDialog v-if="showCustProfile" @commit="custProfileCommit" :visiable.sync="showCustProfile" multi="true" />

  <warehousePop v-if="showWarehousePop" :warehouseType="warehouseType" @commit="warehouseCommit"
    :visiable.sync="showWarehousePop" multi="true" />

  <partsInvPop v-if="showPartsInvPop" @confirm="confirm" :visiable.sync="showPartsInvPop"
    :warehouseId="formData.outWarehouseId" :list="formData.spPartsApplyLineDTOList" multi="true" />

  <auditDialog v-if="showAuditDialog" :form-data="formData" :shippingMethodList="shippingMethodList" @closeD="closeD"
    :visiable.sync="showAuditDialog" multi="true" @goBackIndex="goBackIndex" />

  <closeDialog v-if="showCloseDialog" :dataId="formData.id" :stat="formData.stat" @closeD="closeD"
    :visiable.sync="showCloseDialog" multi="true" @goBackIndex="goBackIndex" :isCancel="isCancel" />
  <!-- 产品弹窗 -->
  <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow" :param="{exchangeShow:1}"
    :visiable.sync="showPreconditionDialog" multi="true" />
  <!-- 产品弹窗 -->
  <preconditionDialog v-if="showMulPreconditionDialog" @commitSelectedRow="commitMulSelectedRow"
    :visiable.sync="showMulPreconditionDialog"
    :param="{ excludeItemIds: this.formData.backList.map(item => item.itemId) }" multi="true" />
  <!-- 可换机型处理 -->
  <zhiPaiDialog v-if="showAssignDialog" :visiable.sync="showAssignDialog" @confirm="commitSelectedRow1" :bigS="bigS"
    :excludeList="siteName" />
        <!-- 文件预览 -->
        <Preview v-if="showPreview" @closeD="closeD33" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />
  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import videoDialog from '@/views/dialogCommon/videoDialog.vue'

import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import accidentPop from '@/views/dialogCommon/radioAccidentDialog.vue'
import qualityPop from '@/views/dialogCommon/radioQualityDialog.vue'
import custProfileDialog from '@/views/dialogCommon/custProfileListDialog.vue'
import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
import { dictType, loadDictData } from "@/config/dictType";
import partsInvPop from '@/views/dialogCommon/partsInvDialog.vue';
import auditDialog from "./auditDialog.vue";
import closeDialog from "./closeDialog.vue";
import { siteMixins } from "@/mixins/tabChang";

// 产品弹窗
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
// import preconditionMulDialog from '@/views/dialogCommon/duochanPinDialog.vue';
import { fetchTree, fetchTree2 } from "@/api/admin/type_tree";
import { mapGetters } from "vuex";
// 流程
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";
//可换机型处理
import zhiPaiDialog from './assignSiteDialog.vue';
// 图片
import PhotoUpload from "@/components/formItem/photoUpload.vue";
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    btn_no: {
      type: Boolean,
      default: true
    },

    type: String
  },

  components: { Preview,PhotoUpload, wfView, auditDialog, closeDialog, orderPop, accidentPop, qualityPop, sitePop, videoDialog, warehousePop, partsInvPop, preconditionDialog, custProfileDialog, zhiPaiDialog },
  data() {
    return {
      callMobile2:null,
      isMustBarcode:true,
      isZd:true,
      imgVisbleURL: '',
      basKnowledgeAdd: false,
      showPreview: false,
      // 查询参数
      queryParams: {
        deptName: ""
      },
      isSite: true,
      callMobile1: '',

      btn_no: true,
      bigS: {},
      numLimit: '0',
      able: true,
      isDirectExchangeDisabled: false,
      // 流程
      processId: '',
      showEdit: false,
      showAssignDialog: false,

      needSourceNo: true,
      writeSourceNo: false,
      disabledSourceNo: false,

      checkOrder: true,
      checkOrderBarcode: false,

      wfData: {
        wfEntityId: ''
      },

      // rules: {
      //   remark: [{required: false, prop: '订单描述', type: 'string', maxlength: 100}],
      //   planMonth: [{required: true, prop: '计划月份',}, {type: 'string', maxlength: 10, msg: '计划月份异常'}],
      //   orgId: [{required: true, prop: '所属中心'}],
      //   siteId: [{required: true, prop: '网点'}],
      //   spPartsPlanLineDTOList: [{required: true, prop: '配件明细', type: 'list', rules: {
      //       planQty: [{prop: '计划数量', required: true, type: 'number'}]
      //   }}],
      //   pic1: [{type: 'string', maxlength: 100, prop: '图片1'}],
      //   pic2: [{type: 'string', maxlength: 100, prop: '图片2'}],
      //   pic3: [{type: 'string', maxlength: 100, prop: '图片3'}]
      // },

      rules: {


        billType: [
          { required: true, prop: '单据类型', message: '单据类型:1退货;2退换货不能为空', trigger: 'blur' }
        ],

        siteId: [
          { required: true, prop: '服务商ID', message: '服务商ID,关联sn_user.id;不能为空', trigger: 'blur' }
        ],

        siteName: [
          { required: true, prop: '服务商名称', message: '服务商名称不能为空', trigger: 'blur' }
        ],

        siteMan: [
          { required: true, prop: '联系人', message: '联系人不能为空', trigger: 'blur' }
        ],

        siteManMobile: [
          { required: true, prop: '联系人电话', message: '联系人电话不能为空', trigger: 'blur' }
        ],

        orgId: [
          { required: true, prop: '部门ID', message: '部门ID，关联脚手架机构表sys_dept.dept_id不能为空', trigger: 'blur' }
        ],

        isDirectExchange: [
          { required: true, prop: '是否直发机', message: '是否直发机:0否1是不能为空', trigger: 'blur' }
        ],

        sourceType: [
          { required: true, prop: '退换来源', message: '退换来源:1安装工单;2维修工单;3委托维修;4事故报告;5质量报告;9其他不能为空', trigger: 'blur' }
        ],

        // sourceNo: [
        //   { required: true, prop: '来源单据', message: '来源单据不能为空', trigger: 'blur' }
        // ],

        exchangeReason: [
          { required: true, prop: '退换原因', message: '退换原因ID，关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        ],

        exchangeReasonName: [
          { required: true, prop: '退换原因名称', message: '退换原因名称,冗余字段不能为空', trigger: 'blur' }
        ],

        exchangeType: [
          { required: true, prop: '退换分类ID', message: '退换分类ID,关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        ],

        exchangeTypeName: [
          { required: true, prop: '退换分类名称', message: '退换分类名称,冗余字段不能为空', trigger: 'blur' }
        ],

        problemRemark: [
          { required: true, prop: '问题描述', message: '问题描述不能为空', trigger: 'blur' }
        ],

        userName: [
          { required: true, prop: '用户姓名', message: '用户姓名不能为空', trigger: 'blur' }
        ],

        userMobile: [
          { required: true, prop: '用户电话', message: '用户电话不能为空', trigger: 'blur' }
        ],

        userProvince: [
          { required: true, prop: '省', message: '省不能为空', trigger: 'blur' }
        ],

        userCity: [
          { required: true, prop: '市', message: '市不能为空', trigger: 'blur' }
        ],

        userCounty: [
          { required: true, prop: '区县', message: '区县不能为空', trigger: 'blur' }
        ],

        // userTown: [
        //   { required: true, prop: '镇街', message: '镇街不能为空', trigger: 'blur' }
        // ],

        areaId: [
          { required: true, prop: '地区ID,关联bas_area.id', message: '地区ID,关联bas_area.id不能为空', trigger: 'blur' }
        ],

        userAddress: [
          { required: true, prop: '详细地址', message: '详细地址不能为空', trigger: 'blur' }
        ],

        itemId: [
          { required: true, prop: '产品', message: '产品Id,关联bas_item.id不能为空', trigger: 'blur' }
        ],

        itemCode: [
          { required: true, prop: '产品编码', message: '产品编码,冗余字段不能为空', trigger: 'blur' }
        ],

        itemName: [
          { required: true, prop: '产品名称', message: '产品名称,冗余字段不能为空', trigger: 'blur' }
        ],

        bigCategoryId: [
          { required: true, prop: '产品大类ID', message: '产品大类ID,关联bas_item_category.id不能为空', trigger: 'blur' }
        ],

        bigCategoryName: [
          { required: true, prop: '产品大类名称', message: '产品大类名称。冗余字段不能为空', trigger: 'blur' }
        ],

        // smallCategoryId: [
        //   { required: true, prop: '产品小类ID', message: '产品小类ID,关联bas_item_category.id不能为空', trigger: 'blur' }
        // ],

        // smallCategoryName: [
        //   { required: true, prop: '产品小类名称', message: '产品小类名称。冗余字段不能为空', trigger: 'blur' }
        // ],

        // gasType: [
        //   { required: true, prop: '气源ID', message: '气源ID，关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        // ],

        // gasTypeName: [
        //   { required: true, prop: '气源名称', message: '气源名称，冗余字段不能为空', trigger: 'blur' }
        // ],

        // barcode: [
        //   { required: true, prop: '产品条码', message: '产品条码不能为空', trigger: 'blur' }
        // ],

        buyDate: [
          { required: true, prop: '购买日期', message: '购买日期不能为空', trigger: 'blur' }
        ],
        buyAmount: [
          { required: true, prop: '购买金额', message: '购买金额不能为空', trigger: 'blur', type: "number", min: "0", max: "100000" }
        ],
        defaultReturnAddress: [
          { required: true, prop: '总部收货异常默认退回地址', message: '总部收货异常默认退回地址不能为空', trigger: 'blur', type: "string", maxlength:"500", minlength:"1", }
        ],

        defaultReturnAreaId: [
          { required: true, prop: '总部收货异常默认退回地区ID', message: '总部收货异常默认退回地区ID不能为空', trigger: 'blur' }
        ],

        // returnLogisticsStat: [
        //   { required: true, prop: '退货状态', message: '退货状态:0未发货;2已发货;5已签收不能为空', trigger: 'blur' }
        // ],

        // returnLogisticsCompany: [
        //   { required: true, prop: '物流公司ID', message: '物流公司ID，关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        // ],

        // returnLogisticsCompanyName: [
        //   { required: true, prop: '物流公司名称', message: '物流公司名称,冗余字段不能为空', trigger: 'blur' }
        // ],

        // returnLogisticsNo: [
        //   { required: true, prop: '物流单号', message: '物流单号不能为空', trigger: 'blur' }
        // ],

        // returnLogisticsSign: [
        //   { required: true, prop: '退货签收时间', message: '退货签收时间不能为空', trigger: 'blur' }
        // ],

        // backLogisticsStat: [
        //   { required: true, prop: '返还状态', message: '返还状态：0未发货;2已发货;5已签收不能为空', trigger: 'blur' }
        // ],

        // backLogisticsCompany: [
        //   { required: true, prop: '物流公司', message: '物流公司ID，关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        // ],

        // backLogisticsCompanyName: [
        //   { required: true, prop: '物流公司名称', message: '物流公司名称,冗余字段不能为空', trigger: 'blur' }
        // ],

        // backLogisticsNo: [
        //   { required: true, prop: '物流单号', message: '物流单号不能为空', trigger: 'blur' }
        // ],

        // backLogisticsSign: [
        //   { required: true, prop: '返还签收时间', message: '返还签收时间不能为空', trigger: 'blur' }
        // ],

        // identifyResult: [
        //   { required: true, prop: '鉴定结果ID', message: '鉴定结果ID，关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        // ],

        // identifyResultName: [
        //   { required: true, prop: '鉴定结果名称', message: '鉴定结果名称，冗余字段不能为空', trigger: 'blur' }
        // ],

        // qualityIdentify: [
        //   { required: true, prop: '质量鉴定ID', message: '质量鉴定ID，关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        // ],

        // qualityIdentifyName: [
        //   { required: true, prop: '质量鉴定名称', message: '质量鉴定名称，冗余字段不能为空', trigger: 'blur' }
        // ],

        // responsibilityIdentify: [
        //   { required: true, prop: '责任鉴定ID', message: '责任鉴定ID，关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        // ],

        // responsibilityIdentifyName: [
        //   { required: true, prop: '责任鉴定名称', message: '责任鉴定名称，冗余字段不能为空', trigger: 'blur' }
        // ],

        // canFix: [
        //   { required: true, prop: '是否可维修', message: '是否可维修:0否1是不能为空', trigger: 'blur' }
        // ],

        // systemSuggestDeal: [
        //   { required: true, prop: '系统建议方案', message: '系统建议方案不能为空', trigger: 'blur' }
        // ],

        // dealWay: [
        //   { required: true, prop: '处理方案ID', message: '处理方案ID,关联脚手架数据字典项目表sys_dict_item.id不能为空', trigger: 'blur' }
        // ],

        // dealWayName: [
        //   { required: true, prop: '处理方案名称', message: '处理方案名称,冗余字段不能为空', trigger: 'blur' }
        // ],

        sysmtomPic: [
          { required: true, prop: '故障点图片', message: '故障点图片不能为空', trigger: 'blur' }
        ],

        installPic: [
          { required: true, prop: '安装环境图片', message: '安装环境图片不能为空', trigger: 'blur' }
        ],

        labelPic: [
          { required: true, prop: '铭牌信息图片', message: '铭牌信息图片不能为空', trigger: 'blur' }
        ],

        barcodePic: [
          { required: true, prop: '产品条码图片', message: '产品条码图片不能为空', trigger: 'blur' }
        ],

        // vedioUrl: [
        //   { required: true, prop: '视频', message: '视频不能为空', trigger: 'blur' }
        // ],

      },

      optionsDisable: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },


      addButton: false,
      editButton: false,
      exportButton: false,
      submitButton: false,
      flowSubmitButton: false,
      cancelButton: false,
      checkButton: false,
      rejectButton: false,

      // 视频上传
      baseImgUrl: 'https:....',
      hideUpload: false,
      limitCount: 1,
      vedioUrl: '',
      dialogVisible: false,
      isShow: false,
      videoList: [],
      picUrl: '....',

      orderType: null,
      isExchange: 1,

      productOptions0: [],
      productOptions1: [],
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      exchangeReasonList: [],
      exchangeTypeList: [],
      gasTypeList: [],
      dictTypesVipLevel: [],
      identifyResultList: [],
      qualityIdentifyList: [],
      responsibilityIdentifyList: [],
      dealWayList: [],
      warehouseList: [],

      url: 'https://t12.baidu.com/it/u=1689026450,3552214048&fm=58',
      srcList: [],
      showPreconditionDialog: false,
      showMulPreconditionDialog: false,

      warehouseType: 0,
      justShow: false,
      showPartsInvPop: false,
      showSitePop: false,
      showVideo: false,

      showOrderPop: false,
      showAccidentPop: false,
      showQualityPop: false,
      showCustProfile: false,
      showWarehousePop: false,
      showAuditDialog: false,
      showCloseDialog: false,
      isCancel: false,
      orgOptions: {},
      orgValue: '',
      areaOption: [],
      areaValues: [],
      defaultReturnOption: [],
      defaultReturnValues: [],
      receiveAreaOption: [],
      receiveAreaValues: [],
      selectedData: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      shippingMethodList: [],
      logisticsCompaniesList: [],

      showPhotoList: [],
      // 原始数据 因为页面上可以修改 导致传流程页面后会有问题
      fixData: {},
      receiveCollapse:["1"],
      formData: {

        exchangeNo: null, //退换单号;自动生成:TH+年月日时分秒+2位随机数
        stat: 1, //单据状态:1制单;2审核中;5已审核;6驳回;99取消
        billType: null, //单据类型:1退货;2退换货
        siteId: null, //服务商ID,关联sn_user.id;
        siteName: null, //服务商名称
        siteMan: null, //联系人
        siteManMobile: null, //联系人电话
        orgId: null, //部门ID，关联脚手架机构表sys_dept.dept_id
        orgName: null, //部门名称,冗余字段
        orgIdPath: null, //部门ID路径,冗余字段.重要
        isDirectExchange: 0, //是否直发机:0否1是
        sourceType: null, //退换来源:1安装工单;2维修工单;3委托维修;4事故报告;5质量报告;9其他
        sourceNo: null, //来源单据
        exchangeReason: null, //退换原因ID，关联脚手架数据字典项目表sys_dict_item.id
        exchangeReasonName: null, //退换原因名称,冗余字段
        exchangeType: null, //退换分类ID,关联脚手架数据字典项目表sys_dict_item.id
        exchangeTypeName: null, //退换分类名称,冗余字段
        problemRemark: null, //问题描述
        outWarehouseId: null, // 出库仓id
        inWarehouseId: null, // 入库仓id
        userName: null, //用户姓名
        userMobile: null, //用户电话
        userProvince: null, //省
        userCity: null, //市
        userCounty: null, //县
        userTown: null, //镇街
        areaId: null, //地区ID,关联bas_area.id
        userAddress: null, //详细地址
        itemId: null, //产品Id,关联bas_item.id
        itemCode: null, //产品编码,冗余字段
        itemName: null, //产品名称,冗余字段
        bigCategoryId: null, //产品大类ID,关联bas_item_category.id
        bigCategoryName: null, //产品大类名称。冗余字段
        smallCategoryId: null, //产品小类ID,关联bas_item_category.id
        smallCategoryName: null, //产品小类名称。冗余字段
        gasType: null, //气源ID，关联脚手架数据字典项目表sys_dict_item.id
        gasTypeName: null, //气源名称，冗余字段
        barcode: null, //产品条码
        buyAmount: null, // 购买金额
        buyDate: null, //购买日期
        returnLogisticsStat: 0, //退货状态:0未发货;2已发货;5已签收
        returnLogisticsCompany: null, //物流公司ID，关联脚手架数据字典项目表sys_dict_item.id
        returnLogisticsCompanyName: null, //物流公司名称,冗余字段
        returnLogisticsNo: null, //物流单号
        returnLogisticsSign: null, //退货签收时间
        backLogisticsStat: 0, //返还状态：0未发货;2已发货;5已签收
        backLogisticsCompany: null, //物流公司ID，关联脚手架数据字典项目表sys_dict_item.id
        backLogisticsCompanyName: null, //物流公司名称,冗余字段
        backLogisticsNo: null, //物流单号
        backLogisticsSign: null, //返还签收时间
        identifyResult: null, //鉴定结果ID，关联脚手架数据字典项目表sys_dict_item.id
        identifyResultName: null, //鉴定结果名称，冗余字段
        qualityIdentify: null, //质量鉴定ID，关联脚手架数据字典项目表sys_dict_item.id
        qualityIdentifyName: null, //质量鉴定名称，冗余字段
        responsibilityIdentify: null, //责任鉴定ID，关联脚手架数据字典项目表sys_dict_item.id
        responsibilityIdentifyName: null, //责任鉴定名称，冗余字段
        canFix: null, //是否可维修:0否1是
        systemSuggestDeal: null, //系统建议方案
        dealWay: null, //处理方案ID,关联脚手架数据字典项目表sys_dict_item.id
        dealWayName: null, //处理方案名称,冗余字段
        qrCode: null,

        receiveMan: null,
        receiveMobile: null,
        receiveProvince: null,
        receiveCity: null,
        receiveCounty: null,
        receiveTown: null,
        receiveAreaId: null,
        receiveAddress: null,

        backAmount: 0,
        differenceAmount: 0,

        sysmtomPic: null, //故障点图片
        installPic: null, //安装环境图片
        labelPic: null, //铭牌信息图片
        barcodePic: null, //产品条码图片
        vedioUrl: null, //视频
        profileId: null,//用户档案Id,关联bas_cust_profile.id
        vipLevel: null,

        send1Flag: null, // 销售传单状态：0未传;1失败;2已传
        send1No: '', // 销售对接单号
        send1Message: '', // 销售传单备注
        erpCustCode: '', // erp客户编码
        send2Flag: null, // 交货传单状态：0未传;1失败;2已传
        send2No: '', // 交货对接单号
        send2Message: '', // 交货传单备注
        send3Flag: null, // 出库传单状态：0未传;1失败;2已传
        send3No: '', // 出库对接单号
        send3Message: '', // 出库传单备注
        send4Flag: null, // 通知入库传单状态：0未传;1失败;2已传
        send4No: '', // 通知入库对接单号
        send4Message: '', // 通知入库传单备注
        send5Flag: null, // 退货传单状态：0未传;1失败;2已传
        send5No: '', // 退货对接单号
        send5Message: '', // 退货传单备注
        send6Flag: null, // 退货传单状态：0未传;1失败;2已传
        send6No: '', // 退货对接单号
        send6Message: '', // 退货传单备注
        send7Flag: null, // 退货传单状态：0未传;1失败;2已传
        send7No: '', // 退货对接单号
        send7Message: '', // 退货传单备注
        send8Flag: null, // 退货传单状态：0未传;1失败;2已传
        send8No: '', // 退货对接单号
        send8Message: '', // 退货传单备注

        defaultReturnProvince: null,
        defaultReturnCity: null,
        defaultReturnCounty: null,
        defaultReturnTown: null,
        defaultReturnAddress: '',
        defaultReturnAreaId: '',

        backList: []
      },

      show3: false,
      node: true,
      ////////////////////////////////////////////////////////////////////////////////////////////
      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if(this.dataId==0){
      this.isZd=false
    }
    if (this.btn_no) this.btn_no = this.btn_no;

    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;
    console.log(this.processId,"this.processId流程ID值");
    this.addButton = this.permissions["wkExchangeBillAdd"];
    this.editButton = this.permissions["wkExchangeBillEdit"];
    this.exportButton = this.permissions["wkExchangeBillExport"];

    this.submitButton = this.permissions["wkExchangeBillSubmit"];
    this.flowSubmitButton = this.permissions["wkExchangeBillFlowSubmit"];
    this.cancelButton = this.permissions["wkExchangeBillCancel"];
    this.checkButton = this.permissions["wkExchangeBillCheck"];
    this.rejectButton = this.permissions["wkExchangeBillReject"];

    const userInfo = store.getters.userInfo;

    // if (userInfo.snUserId) {
    if (this.currentSiteData) {
      this.isSite = true;
      console.log("this.isSite = true;")
    } else {
      this.isSite = false;
    }
  },
  mounted() {
    this.loadOrgData()
    this.loadDictData()
    this.loadWarehouse()
    this.loadProductOption0()
    this.getData()
  },
  watch: {
    // 联系方式验证
    callMobile2: {
      handler(newVal, oldVal) {
        // console.log(newVal,"新值");
        this.formData.userMobile = newVal
        if(this.formData.userMobile){
          var numReg = /^[0-9]+$/
          var numRe = new RegExp(numReg)
          if (!numRe.test(this.formData.userMobile)) {
            // this.$message.error("请输入正确的11位手机号码");
          } else if (this.formData.userMobile.length > 11) {
            this.$message.error("手机号码不能超过11位");
            this.formData.userMobile = this.formData.userMobile.slice(0, 11);
            this.callMobile2 = this.formData.userMobile
          }
        }
      },
      deep: true, // 加这个属性，深度监听
    },

    'formData.outType': {
      handler(n) {
        if (n == 1) {  // 总部
          this.warehouseType = 0
        } else if (n == 2) {   // 中心
          this.warehouseType = 1
        }
      },
      deep: true
    },
    'formData.spPartsApplyLineDTOList': {
      handler(n) {
        if (n) {
          let temp = 0
          let temp1 = 0
          n.forEach(item => {
            temp += Number(item.applyQty)
            temp1 += Number(item.applyQty) * Number(item.sitePrice)
          })
          this.formData.applyQtyAll = temp
          this.formData.applyAmountAll = temp1
        }
      },
      deep: true
    }
  },
  methods: {
    closeD33() {
      this.showPreview = false

    },
    barcodeBlur(){
      // 条码不存在  或者工单已经存在的产品和条码的 不再调用
      if (!this.formData.barcode || this.checkOrderBarcode) {
        return
      }

      this.$http({
        url: api.wkExchangeBill.addDataUrl + 'checkBarcode',
        method: 'post',
        data: {
          barcode: this.formData.barcode,
        }
      }).then(res => {
        console.log(res.data.data)
        this.$set(this.formData, 'applyRemark', res.data.data['result'])
        // this.$message.warning(res.data.data['result'])

        if (res.data.data['hasBarcode']) {
          // 如果已存在条码 且未被使用 则提示不能保存
          this.$message.warning("该条码已存在且未被使用, 不允许申请")
          this.hasBarcode = true
          return;
        } else {
          this.hasBarcode = false
        }

        // if (res.data.data == '系统找不到此条码') {
        if (res.data.data['hasItem']) {
          this.formData.itemId = res.data.data['itemId']
          this.formData.itemCode = res.data.data['itemCode']
          this.formData.itemName = res.data.data['itemName']
          this.formData.bigCategoryId = res.data.data['bigCategoryId']
          this.formData.smallCategoryId = res.data.data['smallCategoryId']
          this.formData.bigCategoryName = res.data.data['bigCategoryName']
          this.formData.smallCategoryName = res.data.data['smallCategoryName']
          this.checkOrder = true
        } else {
          this.formData.barcode = ''
          this.checkOrder = true
          this.checkOrderBarcode = false
          this.$message.warning(res.data.data['result'])
        }
      })
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },

    // 视频下载
    handleDownload(Vname,Vurl) {
      console.log(Vname,Vurl, "视频下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    reloadWf() {
      console.log('保存前的刷新');
      // this.$emit('editViewDataUpdate')
      this.reload()
    },
    commitSelectedRow1(data) {
      console.log(data, '网点选中')
      let temp = this.siteName
      if (temp.length === 0) {
        this.siteName = data
      } else {
        data.forEach(item => {
          temp.push(item)
        })
      }
    },
    ableShowMulPreconditionDialog() {
      if (this.able) {
        return this.$message.warning('无法操作')
      } else {
        this.showMulPreconditionDialog = true
      }
    },
    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,  // 产品
        // usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },
    // 加载产品小类
    loadProductOption1() {
      if (this.formData.bigCategoryId === ''
        || this.formData.bigCategoryId === null
        || this.formData.bigCategoryId === undefined) {
        this.productOptions1 = []
      } else {
        fetchTree({
          categoryType: 1,  // 产品
          // usable: 1,  // 加载启用的
          parentId: this.formData.bigCategoryId
        }).then(response => {
          this.productOptions1 = []
          response.data.data.forEach(item => {
            this.productOptions1.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },
    // 产品大类选中加载小类
    productSelectOne() {
      this.productOptions1 = []
      this.formData.smallCategoryId = null
      this.loadProductOption1()
    },
    commitSelectedRow(data) {

      console.log(data, 'data传过来的值  编码');
      this.formData.itemId = data.id
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.smallCategoryName = data.smallCategoryName
    },
    commitMulSelectedRow(data) {

      console.log(data, 'data传过来的值  编码');
      this.formData.backList.push({
        selectId: -new Date().getTime() + Math.floor(Math.random() * 100),
        itemId: data.id,
        itemCode: data.itemCode,
        itemName: data.itemName,
        bigCategoryId: data.bigCategoryId,
        bigCategoryName: data.bigCategoryName,
        smallCategoryId: data.smallCategoryId,
        smallCategoryName: data.smallCategoryName,
        qty: 1,
      })
    },
    deleteItemData() {
      if (this.able) {
        return this.$message.warning('无法操作')
      }
      let selectedData = this.selectedData
      if (selectedData == null || selectedData.length == 0) {
        this.$message.warning('请先选中数据')
      } else {
        let backList = this.formData.backList;
        selectedData.forEach(item => {
          backList = backList.filter(item1 => item1.selectId != item.selectId)
        })
        this.formData.backList = backList
      }
    },
    exchangeTypeChange() {
      this.isDirectExchangeDisabled = false
      if (this.formData.exchangeType) {
        this.exchangeTypeList.forEach(item => {
          if (this.formData.exchangeType === item.value && item.label == '委托维修') {
            this.formData.isDirectExchange = 0
            this.isDirectExchangeDisabled = true
          }
        })
      }
    },
    sourceTypeChange() {
      this.formData.sourceNo = ""

      this.formData.userName = null
      this.callMobile2=null
      this.formData.userMobile = null
      this.formData.vipLevel = null
      this.formData.areaValues=[]
      this.formData.areaId = null;
      this.formData.country = null;
      this.formData.userProvince = null;
      this.formData.userCity = null;
      this.formData.userCounty = null;
      this.formData.userTown = null;
      this.formData.itemId = null
      this.formData.itemCode = null
      this.formData.itemName = null
      this.formData.bigCategoryId = null
      this.formData.bigCategoryName = null
      this.formData.smallCategoryId = null
      this.formData.smallCategoryName = null
      this.formData.barcode = null
      this.formData.gasType = null
      this.formData.gasTypeName = null
      this.formData.buyDate = null
      this.formData.profileId = null


      this.checkOrder = true
      this.isMustBarcode = true
      if (this.formData.sourceType == 5){
        this.isMustBarcode = false
      }
      this.sourceTypeShow()
    },
    sourceTypeShow() {
      if (this.formData.sourceType == 3) {
        this.needSourceNo = false;
        this.writeSourceNo = true;
        this.disabledSourceNo = false;
      } else if (this.formData.sourceType == 9) {
        this.needSourceNo = false;
        this.writeSourceNo = false;
        this.disabledSourceNo = true;
      } else {
        this.needSourceNo = true;
        this.writeSourceNo = false;
        this.disabledSourceNo = false;
      }
    },

    searchOrder() {
      let sourceType = this.formData.sourceType;
      console.log("sourceType" + sourceType);
      let errorMsg = '';
      if (!this.formData.siteId) {
        errorMsg += '网点 '
      }
      if (!sourceType) {
        errorMsg += '退换来源 '
      }

      if (errorMsg) {
        this.$message.error("请选择" + errorMsg);
        return false;
      }

      if (sourceType == 1 || sourceType == 2) {
        this.orderType = sourceType;
        this.showOrderPop = true;
      } else if (sourceType == 4) {
        this.showAccidentPop = true;
      } else if (sourceType == 5) {
        this.showQualityPop = true;
      } else if (sourceType == 3 || sourceType == 9) {
        // this.orderType = 29;
        // this.showOrderPop = true;
      }
    },



    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    // 添加明细
    confirm(data) {
      console.log(data, '明细')
      let temp = this.formData.spPartsApplyLineDTOList
      if (temp == null) {
        temp = []
      }
      data.forEach(item => {
        temp.push({
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.price,
          applyQty: 1,
          applyAmount: item.price,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          getQty: 0,
          getAmount: 0,
          diffQty: 0,
          diffAmount: 0,
          getStat: 0,
          selectId: item.id
        })
      })
      this.formData.spPartsApplyLineDTOList = temp
    },

    // 抽屉关闭
    closeD() {
      this.showAuditDialog = false
      this.showCloseDialog = false
    },


    deleteData() {
      let temp = this.formData.spPartsApplyLineDTOList
      this.selectedData.forEach(item => {
        temp = temp.filter(item1 => item1.selectId != item.selectId)
      })
      this.formData.spPartsApplyLineDTOList = temp
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },


    // 加载数据字典中物流公司，运输方式

    loadWarehouse() {
      this.$http.get(api.wkExchangeBill.addDataUrl + 'getOutWarehouse', {
      }).then(res => {
        this.warehouseList = res.data.data
      })
    },

    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })

      // vip级别
      loadDictData('VIP级别').then(res => {
        this.dictTypesVipLevel = res.data.data
      })

      // 运输方式
      loadDictData(dictType.shippingMethod).then(res => {
        this.shippingMethodList = []
        res.data.data.forEach(item => {
          this.shippingMethodList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("退换原因").then(res => {
        this.exchangeReasonList = []
        res.data.data.forEach(item => {
          this.exchangeReasonList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("退换分类").then(res => {
        this.exchangeTypeList = []
        res.data.data.forEach(item => {
          this.exchangeTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("气源名称").then(res => {
        this.gasTypeList = []
        res.data.data.forEach(item => {
          this.gasTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("鉴定结果").then(res => {
        this.identifyResultList = []
        res.data.data.forEach(item => {
          this.identifyResultList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("质量鉴定").then(res => {
        this.qualityIdentifyList = []
        res.data.data.forEach(item => {
          this.qualityIdentifyList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("责任鉴定").then(res => {
        this.responsibilityIdentifyList = []
        res.data.data.forEach(item => {
          this.responsibilityIdentifyList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("处理方案名称").then(res => {
        this.dealWayList = []
        res.data.data.forEach(item => {
          this.dealWayList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    getItemPrice(itemId) {
      this.$http({
        url: api.basItemPrice.getItemPriceByItemId + "/" + itemId,
        method: 'get',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        if (res.data.data) {
          this.formData.buyAmount = res.data.data.price
        }
      })
    },


    // 仓库弹框选中
    warehouseCommit(data) {
      console.log('选中的仓库', data)
      this.formData.outWarehouseId = data.warehouseId
      this.formData.outWarehouseName = data.warehouseName
    },

    // 工单弹框选中
    orderCommit(data) {
      console.log('选中的工单', data)
      this.formData.orderId = data.orderId
      this.formData.sourceNo = data.orderNo
      this.formData.userName = data.userName
      this.callMobile2 = data.userMobile
      this.formData.userMobile = data.userMobile
      // if (this.formData.siteId) {
      //   this.formData.siteId = data.siteId
      //   this.formData.siteName = data.siteName
      // } else {
      //   this.formData.siteId = data.bigSiteId
      //   this.formData.siteName = data.bigSiteName
      // }
      this.formData.siteMan = data.siteMan
      this.formData.siteManMobile = data.siteManMobile
      this.callMobile1 = data.siteManMobile
      this.orgValue = data.orgId
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath
      this.formData.areaId = data.areaId
      this.formData.userProvince = data.userProvice
      this.formData.userCity = data.userCity
      this.formData.userCounty = data.userCounty
      this.formData.userTown = data.userTown
      this.formData.userAddress = data.userAddress
      this.formData.itemId = data.itemId
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.smallCategoryName = data.smallCategoryName
      this.formData.buyDate = data.buyDate
      this.formData.profileId = data.profileId
      this.formData.barcode = data.resultBarcode
      if (!!this.formData.itemId) {
        this.checkOrder = true
      }
      if (!!this.formData.barcode) {
        this.checkOrderBarcode = true
      }
      this.echoAddress()
      this.loadProductOption1()
      if (data.itemId) {
        this.getItemPrice(data.itemId)
      }
      if (this.formData.profileId) {
        this.getCustmerInfo()
      }
    },
    // 事故报告单弹框选中
    accidentCommit(data) {
      console.log('选中的工单', data)
      this.formData.orderId = data.orderId
      this.formData.sourceNo = data.reportNo
      this.formData.userName = data.userName
      this.formData.userMobile = data.userMobile
      this.formData.siteId = data.siteId
      this.formData.siteName = data.siteName
      this.formData.siteMan = data.siteMan
      this.formData.siteManMobile = data.siteManMobile
      this.callMobile1 = data.siteManMobile
      this.orgValue = data.orgId
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath
      this.formData.areaId = data.areaId
      this.formData.userProvince = data.userProvice
      this.formData.userCity = data.userCity
      this.formData.userCounty = data.userCounty
      this.formData.userTown = data.userTown
      this.formData.userAddress = data.userAddress
      this.formData.itemId = data.itemId
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.smallCategoryName = data.smallCategoryName
      this.formData.buyDate = data.buyDate
      this.formData.profileId = data.profileId
      if (!!this.formData.itemId) {
        this.checkOrder = true
      }
      if (!!this.formData.barcode) {
        this.checkOrderBarcode = true
      }
      if (this.formData.profileId) {
        this.getCustmerInfo()
      }
      this.echoAddress()
      this.loadProductOption1()
    },
    // 质量报告单弹窗
    qualityCommit(data) {
      console.log('选中的工单', data)
      this.formData.orderId = data.orderId
      this.formData.sourceNo = data.reportNo
      this.formData.userName = data.userName
      this.formData.userMobile = data.userMobile
      this.formData.siteId = data.siteId
      this.formData.siteName = data.siteName
      this.formData.siteMan = data.siteMan
      this.formData.siteManMobile = data.siteManMobile
      this.callMobile1 = data.siteManMobile
      this.orgValue = data.orgId
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath
      this.formData.areaId = data.areaId
      this.formData.userProvince = data.userProvice
      this.formData.userCity = data.userCity
      this.formData.userCounty = data.userCounty
      this.formData.userTown = data.userTown
      this.formData.userAddress = data.userAddress
      this.formData.itemId = data.itemId
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.smallCategoryName = data.smallCategoryName
      this.formData.buyDate = data.buyDate
      this.formData.profileId = data.profileId
      if (!!this.formData.itemId) {
        this.checkOrder = true
      }
      if (!!this.formData.barcode) {
        this.checkOrderBarcode = true
      }
      if (this.formData.profileId) {
        this.getCustmerInfo()
      }
      this.echoAddress()
      this.loadProductOption1()
    },


    getCustmerInfo() {
      // 如果存在用户档案 需要查询下用户档案vip等级 避免在工单查询中带
      this.$http({
        url: api.basCustProfile.getDataUrl,
        method: 'post',
        data: {
          id: this.formData.profileId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        console.log('res', response.data.data)
        let data = response.data.data

        this.formData.vipLevel = data.vipLevel
      })
    },

    // 用户档案弹框选中
    custProfileCommit(data) {
      console.log('选中的用户', data)
      this.formData.profileId = data.id
      this.formData.profileNo = data.profileNo
      this.formData.userType = data.userType
      this.formData.userMobile = data.callMobile
      this.formData.userName = data.custName
      this.formData.vipLevel = data.vipLevel
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的数据', data)
      console.log('选中的网点', data.id)
      console.log('选中的网点', this.formData.siteId)
      if (this.formData.siteId !== data.id) {
        this.formData.sourceNo = '';
      }
      this.formData.siteId = data.id
      this.formData.siteName = data.name
      this.orgValue = data.orgId
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath


      console.log('修改后的数据', this.formData)
    },
    // 视频上传文件
    commitVideo(data) {
      console.log('选中的视频数据', data)
      this.formData.vedioName=data.vedioName
      this.formData.vedioUrl=data.vedioUrl





      // console.log('修改后的数据', this.formData)
    },

    // 加载机构数据
    loadOrgData() {
      fetchTree2(this.queryParams).then(response => {
        this.orgOptions = response.data.data
        // this.orgOptions =res.data.data
        console.log(this.orgOptions, "this.orgOptions的值");

      });

    },

    // 加载机构数据
    // loadOrgData() {
    //   this.$http({
    //     url: api.sysDept.getDataUrl,
    //     method: 'post',
    //     data: {}
    //   }).then(res => {
    //     console.log(res.data.data)
    //     this.orgOptions = []
    //     res.data.data.forEach(item => {
    //       let temp = {
    //         value: item.id,
    //         label: item.name,
    //       }
    //       if (item.hasChild) {
    //         temp.children = []
    //         item.child.forEach(item1 => {
    //           temp.children.push({
    //             value: item1.deptId,
    //             label: item1.name
    //           })
    //         })
    //       }
    //       this.orgOptions.push(temp)
    //     })
    //   })
    // },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },
    clearSite() {
      this.formData.siteId = '';
    },
    clearSourceType() {
      this.formData.sourceNo = '';
    },

    // 地址选中事件
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.userProvince = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvince = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null;
        this.formData.country = null;
        this.formData.userProvince = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    // 地址选中事件
    handleChange2() {
      const areaNode = this.$refs["cascader2"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.receiveCountry = areaNode[0].label;
          this.formData.receiveProvince = null;
          this.formData.receiveCity = null;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.receiveProvince = areaNode[0].label;
          this.formData.receiveCity = null;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.receiveCity = areaNode[0].label;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.receiveCounty = areaNode[0].label;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.receiveTown = areaNode[0].label;
        }
        this.formData.receiveAreaId = areaNode[0].value
      } else {
        this.formData.receiveAreaId = null;
        this.formData.receiveCountry = null;
        this.formData.receiveProvince = null;
        this.formData.receiveCity = null;
        this.formData.receiveCounty = null;
        this.formData.receiveTown = null;
      }

      const panelRefs = this.$refs.cascader2.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },
    // 地址选中事件
    handleChange3() {
      const areaNode = this.$refs["cascader3"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.defaultReturnCountry = areaNode[0].label;
          this.formData.defaultReturnProvince = null;
          this.formData.defaultReturnCity = null;
          this.formData.defaultReturnCounty = null;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.defaultReturnProvince = areaNode[0].label;
          this.formData.defaultReturnCity = null;
          this.formData.defaultReturnCounty = null;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.defaultReturnCity = areaNode[0].label;
          this.formData.defaultReturnCounty = null;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.defaultReturnCounty = areaNode[0].label;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.defaultReturnTown = areaNode[0].label;
        }
        this.formData.defaultReturnAreaId = areaNode[0].value
      } else {
        this.formData.defaultReturnAreaId = null;
      }

      const panelRefs = this.$refs.cascader3.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },


    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '' && this.formData.areaId != 0) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.areaId }
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
      if (!!(this.formData.receiveAreaId)) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.receiveAreaId }
        }).then(res => {
          console.log(res)
          this.receiveAreaOption = res.data.data.options
          this.receiveAreaValues = res.data.data.values
          this.receiveArea = res.data.data.names
        })
      }
      if (!!(this.formData.defaultReturnAreaId)) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.defaultReturnAreaId }
        }).then(res => {
          console.log(res)
          this.defaultReturnOption = res.data.data.options
          this.defaultReturnValues = res.data.data.values
          this.defaultReturnArea = res.data.data.names
        })
      }
    },

    testIntf() {
      this.$validate().then(() => {
        this.$baseConfirm('您确定要重新发送吗？').then(() => {
          this.$mask.open()
          console.log(this.formData.vedioUrl, 'this.formData.vedioUrl的值');
          var url = (this.isEdit ? api.wkExchangeBill.updateDataUrl : api.wkExchangeBill.addDataUrl);
          var method = 'put';
          this.$http({
            url: url + "testIntf",
            method: method,
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$message.success("保存成功！");
            this.getData()
            this.$mask.close()

            // this.$emit('editViewDataUpdate')
            // this.$baseReload()
          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });;
        })
      })
    },


    saveData(formName) {
      if (this.isMustBarcode && !this.formData.barcode){
        this.$message.error("产品条码必填！");
        return
      }

      if (!this.formData.receiveMan){
        this.$message.error("收货人姓名必填！");
        return
      }

      if (!this.formData.receiveMobile){
        this.$message.error("收货人联系方式必填！");
        return
      }


      if (!this.formData.receiveAreaId){
        this.$message.error("收货人收货地址必填！");
        return
      }


      if (!this.formData.receiveAddress){
        this.$message.error("收货人详细地址必填！");
        return
      }


      let deliverType = this.formData.deliverType;
      if (deliverType) {
        this.shippingMethodList.forEach(item => {
          if (deliverType === item.value) {
            this.formData.deliverTypeName = item.label
          }
        })
      }

      let deliverCompany = this.formData.deliverCompany;
      if (deliverCompany) {
        this.logisticsCompaniesList.forEach(item => {
          if (deliverCompany === item.value) {
            this.formData.deliverCompanyName = item.label
          }
        })
      }

      if (this.formData.exchangeReason) {
        this.exchangeReasonList.forEach(item => {
          if (this.formData.exchangeReason === item.value) {
            this.formData.exchangeReasonName = item.label
          }
        })
      }
      if (this.formData.exchangeType) {
        this.exchangeTypeList.forEach(item => {
          if (this.formData.exchangeType === item.value) {
            this.formData.exchangeTypeName = item.label
          }
        })
      }
      if (this.formData.gasType) {
        this.gasTypeList.forEach(item => {
          if (this.formData.gasType === item.value) {
            this.formData.gasTypeName = item.label
          }
        })
      }
      if (this.formData.returnLogisticsCompany) {
        this.logisticsCompaniesList.forEach(item => {
          if (this.formData.returnLogisticsCompany === item.value) {
            this.formData.returnLogisticsCompanyName = item.label
          }
        })
      }
      if (this.formData.backLogisticsCompany) {
        this.logisticsCompaniesList.forEach(item => {
          if (this.formData.backLogisticsCompany === item.value) {
            this.formData.backLogisticsCompanyName = item.label
          }
        })
      }
      if (this.formData.identifyResult) {
        this.identifyResultList.forEach(item => {
          if (this.formData.identifyResult === item.value) {
            this.formData.identifyResultName = item.label
          }
        })
      }
      if (this.formData.qualityIdentify) {
        this.qualityIdentifyList.forEach(item => {
          if (this.formData.qualityIdentify === item.value) {
            this.formData.qualityIdentifyName = item.label
          }
        })
      }
      if (this.formData.responsibilityIdentify) {
        this.responsibilityIdentifyList.forEach(item => {
          if (this.formData.responsibilityIdentify === item.value) {
            this.formData.responsibilityIdentifyName = item.label
          }
        })
      }
      if (this.formData.dealWay) {
        this.dealWayList.forEach(item => {
          if (this.formData.dealWay === item.value) {
            this.formData.dealWayName = item.label
          }
        })
      }
      if ((this.formData.sourceType != 9 && this.formData.sourceType != 3) && !this.formData.sourceNo) {
        this.$message.error("来源单据必填");
        return false;
      }
      // if (this.callMobile1.length!=11) {
      //   this.$message.error("请输入正确的联系人电话");
      //   return
      // }
      this.formData.siteManMobile = this.callMobile1

      this.$validate(this.formData, this.rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          console.log(this.formData.vedioUrl, 'this.formData.vedioUrl的值');
          var url = (this.isEdit ? api.wkExchangeBill.updateDataUrl : api.wkExchangeBill.addDataUrl);
          var method = (this.isEdit ? 'put' : 'post');
          this.$http({
            url: url,
            method: method,
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$message.success("保存成功！");
            this.getData()
            this.$mask.close()

            // this.$emit('editViewDataUpdate')
            // this.$baseReload()
          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });
        })
      })

      // this.$refs.editForm.validate(valid => {
      //   if (valid) {
      //     this.$baseConfirm('您确定要保存吗？').then(() => {
      //       var url = (this.isEdit ? api.wkExchangeBill.updateDataUrl : api.wkExchangeBill.addDataUrl);
      //       var method = (this.isEdit ? 'put' : 'post');
      //       this.$http({
      //         url: url,
      //         method: method,
      //         data: this.formData,
      //         isLoading: true,
      //       }).then(response => {
      //         this.$message.success("保存成功！");
      //         this.reload()
      //         // this.$emit('editViewDataUpdate')
      //         // this.$baseReload()
      //       });
      //     });
      //   }
      // });
    },

    getData() {
      // console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.wkExchangeBill.getDataUrl + this.dataId,
          method: 'get',
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if (data.spPartsApplyOperationDTOList === null || data.spPartsApplyOperationDTOList === undefined) {
            data.spPartsApplyOperationDTOList = []
          }
          this.formData = data
          this.srcList.push(data.qrCode)
          this.fixData = {...{}, ...data}
          this.callMobile1 = this.formData.siteManMobile

          console.log(this.formData, "this.formData 的值");
          if(this.formData.stat==1 || this.formData.stat==6){
      this.isZd=false
    }
          this.justShow = this.formData.stat != 1 && this.formData.stat != 6
          // this.videoList = echoFileFormat(data.vedioUrl)
          // this.picList1 = echoFileFormat(data.sysmtomPic)
          this.picList2 = echoFileFormat(data.installPic)
          this.picList3 = echoFileFormat(data.labelPic)
          this.picList4 = echoFileFormat(data.barcodePic)
          // this.picList5 = echoFileFormat(data.vedioUrl)
          this.orgValue = data.orgId
          this.echoAddress()
          let big = {}
          big.bigCategoryId = this.formData.bigCategoryId,
          big.bigCategoryName = this.formData.bigCategoryName,
          big.smallCategoryId = this.formData.smallCategoryId,
          big.smallCategoryName = this.formData.smallCategoryName,
          this.bigS = big
          console.log(this.bigS, "this.big6666666的值");

          this.sourceTypeShow()
          this.loadProductOption1()
        })
      } else {
        this.enabled = true;
        if (this.currentSiteData !== null) { //网点端
          console.log("this.currentSiteData", this.currentSiteData)
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
        }
      }
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },
    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },
    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },
    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = echoFileFormat(res.data.url)
    },
    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList5 = echoFileFormat(res.data.url)
    },


    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      // this.upload_btn = false;
    },

    // // 上传成功
    // handleSuccess4(res, file, picIndex) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn4 = true;
    //   // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
    //   // Vue.set(this.tenant.businessPhoto,)

    // },
    // handleRemove4(response, file) {
    //   // 上传成功后，显示上传按钮
    //   this.upload_btn4 = false;
    // },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 视频js
    // 视频上传


    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList);
      // 调删除图片接口
      // deleteFileByName({ fileName: this.form.url }).then(res => {
      //   if (res.code == 200) {
      //     // this.form.url = ''
      //     // this.form.time = ''
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     });
      //     this.isShow = false
      //   }
      // })

    },
    handlePictureCardPreview2(file) {
      console.log(file, file.url, "99999")
      this.formData.vedioUrl = file.url;
      this.dialogVisible = true;
    },
    uploadPictureSuccess(res, file) {
      var _this = this
      if (file.status == "success") {
        _this.$message({
          message: '视频上传成功',
          type: 'success'
        })
        console.log(res, '上传成功后的res视频');
        this.formData.vedioUrl = res.data.url

      }
      // this.form.url = res.msg
      // this.formData.vedioUrl = file.url;
      // console.log( file.url," file.url的值");
      this.isShow = true

    },
    uploadPictureChange(file, fileList) {
      console.log(file, fileList)
      let _this = this
      this.hideUpload = fileList.length >= this.limitCount;
      var audioElement = new Audio(file.url), duration;
      audioElement.addEventListener("loadedmetadata", function () {
        // _this.form.time = audioElement.duration;
        // console.log('时长：' + _this.form.time + 's')
      })
    },
    commit(statName) {
      let url = api.wkExchangeBill.getDataUrl;
      if (statName == '提交') {
        url += "submit";
      } else if (statName == '审核') {
        url += "check";
      } else if (statName == '取消') {
        url += "cancel";
      } else if (statName == '驳回') {
        url += "reject";
      }

      this.$baseConfirm('您确定要' + statName + '吗？').then(() => {
        this.$http({
          url: url,
          method: 'post',
          data: {
            id: this.formData.id,
          },
          isLoading: true,
        }).then(response => {
          this.$message.success(statName + "成功！");
          this.getData()
        });
      });
    },
    startFlow() {
      this.$baseConfirm('您确定要启动流程吗？').then(() => {
        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data: { id: this.formData.id, tableKey: "WkExchangeBill", orgId: this.formData.orgId, orderNo: this.formData.exchangeNo },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({ message: response.data.content, type: 'success' });
            this.getData();
          } else {
            this.$message({ message: response.data.content, type: 'warning' });
          }
        })
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  // display:none;
  width: 0px;
  height: 0px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}


.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;
  // padding: 5px 0px!important;
  ;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}

::v-deep .is-success {
  position: relative;
}

::v-deep .videoUpload {
  position: relative;
}

::v-deep .avatar {
  position: absolute;
  width: 130px;
  height: 70px;
  top: -20px;
  left: 70px;
}

// ::v-deep .el-upload-list--picture-card{
//   position: absolute;
//   z-index: 999;

// }
// ::v-deep .el-upload-list--picture-card .el-upload-list__item{
//   background: transparent;
// }
/* 推荐，实现简单 */
>>>.el-upload-list__item.is-ready,
.el-upload-list__item.is-uploading {
  display: none !important;
}

::v-deep .el-upload-list__item {
  transition: none !important;
}

.amount {
  margin: 10px 0 0 200px;
  color: #00c4b3;
  font-size: 13px;
}

.videoAdd {
  width: 40px;
  height: 40px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  line-height: 40px;

}

::v-deep .el-image {
  border: none !important;
}
.videoP{
  margin-left:10px;
  padding:5px;
  border: 1px solid #e8e8e8;
    width: 120px;
    display: flex;
    justify-content: space-between;
    border-radius:3px;
}
.imgY{
  position: absolute;
    height: 35px;
    width: 35px;
    top: 0;
    background-color: #c6c2c2;
    opacity: 0.9;
    text-align: center;
    line-height: 35px;
    font-size: 30px;
    display: none;
}
.videoImg:hover  .imgY{

    display:block

}
</style>
